/* global axios */
import ApiClient from './ApiClient';

class LiaAgentsAPI extends ApiClient {
  constructor() {
    super('lia_agents', { accountScoped: true });
  }

  getTemplates() {
    return axios.get(`${this.url}/templates`);
  }

  getEntitlements() {
    return axios.get(`${this.url}/entitlements`);
  }

  activate(id) {
    return axios.post(`${this.url}/${id}/activate`);
  }

  deactivate(id) {
    return axios.post(`${this.url}/${id}/deactivate`);
  }

  deployWorkflow(id) {
    return axios.post(`${this.url}/${id}/deploy_workflow`);
  }

  redeployWorkflow(id, password) {
    return axios.post(`${this.url}/${id}/deploy_workflow`, {
      force: true,
      password,
    });
  }

  syncKnowledge(id) {
    return axios.post(`${this.url}/${id}/sync_knowledge`);
  }

  getWorkflowStatus(id) {
    return axios.get(`${this.url}/${id}/workflow_status`);
  }

  updateIntegration(id, integrationData) {
    return axios.post(`${this.url}/${id}/update_integration`, integrationData);
  }

  updateTestMode(id) {
    return axios.post(`${this.url}/${id}/update_test_mode`);
  }

  updateModules(id, modules) {
    return axios.post(`${this.url}/${id}/update_modules`, { modules });
  }

  savePrompts(id, agentPrompts) {
    return axios.post(`${this.url}/${id}/save_prompts`, {
      agent_prompts: agentPrompts,
    });
  }

  saveSystemPrompt(id, systemPrompt) {
    return axios.post(`${this.url}/${id}/save_prompts`, {
      system_prompt: systemPrompt,
    });
  }

  saveWorkflowConfig(id, workflowConfig) {
    return axios.post(`${this.url}/${id}/save_workflow_config`, {
      workflow_config: workflowConfig,
    });
  }

  saveIntegration(id, { apiUrl, apiToken }) {
    return axios.post(`${this.url}/${id}/save_integration`, {
      api_url: apiUrl,
      api_token: apiToken,
    });
  }

  verifyPassword(id, password) {
    return axios.post(`${this.url}/${id}/verify_password`, { password });
  }

  deleteWithPassword(id, password) {
    return axios.delete(`${this.url}/${id}`, {
      params: { password },
    });
  }

  testNaviApi(id, apiUrl, apiToken) {
    return axios.post(`${this.url}/${id}/test_navi_api`, {
      api_url: apiUrl,
      api_token: apiToken,
    });
  }

  improvePrompt(data) {
    return axios.post(`${this.url}/improve_prompt`, data);
  }

  // Knowledge Base
  getKnowledgeItems(agentId) {
    return axios.get(`${this.url}/${agentId}/knowledge_items`);
  }

  createKnowledgeItem(agentId, data) {
    return axios.post(`${this.url}/${agentId}/knowledge_items`, data);
  }

  createKnowledgeItemWithFile(agentId, formData) {
    return axios.post(`${this.url}/${agentId}/knowledge_items`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  updateKnowledgeItem(agentId, itemId, data) {
    return axios.patch(
      `${this.url}/${agentId}/knowledge_items/${itemId}`,
      data
    );
  }

  deleteKnowledgeItem(agentId, itemId) {
    return axios.delete(`${this.url}/${agentId}/knowledge_items/${itemId}`);
  }

  reprocessKnowledgeItem(agentId, itemId) {
    return axios.post(
      `${this.url}/${agentId}/knowledge_items/${itemId}/reprocess`
    );
  }
}

export default new LiaAgentsAPI();
